export default {
   path: '/multicotizador/cliente',
   name: 'cliente',
   children: [
      {
         path: 'alta',
         name: 'cliente/alta',
         component: () => import('@/modules/client/views/ClienteView.vue'),
      },
   ],
};
